import { render, staticRenderFns } from "./FormRL08.vue?vue&type=template&id=0f2f1222"
import script from "./FormRL08.vue?vue&type=script&lang=js"
export * from "./FormRL08.vue?vue&type=script&lang=js"
import style0 from "./FormRL08.vue?vue&type=style&index=0&id=0f2f1222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports